import { render, staticRenderFns } from "./BasicLabelToggle.vue?vue&type=template&id=29a2e1e6&"
import script from "./BasicLabelToggle.vue?vue&type=script&lang=js&"
export * from "./BasicLabelToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports